import React, { useEffect } from "react";
import HeroBanner from "../../components/DynamicHero";
import Intro from "../../components/outdoor-sport/Intro";
import WhyChooseUs from "../../components/outdoor-sport/WhyChooseUs";
import EshopOutdoorSport from "../../components/outdoor-sport/EshopOutdoorsport";
import { setMetaTag, setPropertyMetaTag } from "../../helpers/seoUtils";
import { useTranslation } from "react-i18next";

const OutdoorSportsPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = "Outdoor Sports Equipment – Economus";

    setMetaTag(
      "description",
      "Explore our high-quality outdoor sports equipment designed for schools, communities, and recreational areas in Lithuania."
    );
    setMetaTag(
      "keywords",
      "Outdoor sports, sports equipment Lithuania, Economus, playground sports gear, lauko sporto įranga"
    );
    setMetaTag("robots", "index, follow");
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", "Outdoor Sports Equipment – Economus");
    setMetaTag(
      "twitter:description",
      "Durable and safe outdoor sports installations for every environment."
    );
    setMetaTag(
      "twitter:image",
      "https://economus.netlify.app/static/media/outdoor-sport3.cc6575b0e1fafa18dd7f.avif"
    );
    setMetaTag("language", "lt");
    setMetaTag("geo.region", "LT");
    setMetaTag("geo.placename", "Lithuania");

    setPropertyMetaTag("og:title", "Outdoor Sports Equipment – Economus");
    setPropertyMetaTag(
      "og:description",
      "Discover professional-grade outdoor sports installations tailored to your needs."
    );
    setPropertyMetaTag(
      "og:image",
      "https://economus.netlify.app/static/media/outdoor-sport3.cc6575b0e1fafa18dd7f.avif"
    );
    setPropertyMetaTag(
      "og:url",
      "https://economus.netlify.app/products/outdoor-sports"
    );
    setPropertyMetaTag("og:type", "website");
  }, []);

  return (
    <>
      <HeroBanner text={t("navTranslate.outdoor_sports")} />
      <Intro />
      <WhyChooseUs />
      <EshopOutdoorSport />
    </>
  );
};

export default OutdoorSportsPage;
